export default __webpack_public_path__ + "5bcbd1aa994d37254605b4605782413e.png";